import React from 'react'
import Layout from '../../common/LayoutNotFound'
import NotFound from './NotFound'

export default {

  path: '*',

  action () {
    const title = 'Page Not Found'

    return {
      title,
      component: <Layout noContainerWell ><NotFound /></Layout>,
      status: 404
    }
  }

}
